import { Injectable } from '@angular/core';
import { CpmService } from './cpm.service';
import { Subscription } from '../../../node_modules/rxjs';

@Injectable()
export class AuthorizeService {
  successLoadFlag = false
  private userCredential: Object = { authorities: [] };
  private roleSubject: Subscription;
  constructor(private cpmService: CpmService) { }

  hasRole(desiredRole: String) {
    if (!this.roleSubject) {
      this.roleSubject = this.cpmService
        .getAuthorities()
        .subscribe(response => (
          this.userCredential = response,
          this.successLoadFlag = true
        ));
    }
    return (this.userCredential['authorities'] as Array<String>).includes(
      desiredRole
    );
  }

  getUserId(): Number {
    return this.userCredential['id'];
  }

  getUserFirstNameEng(): String {
    return this.userCredential['firstNameEng'];
  }

  getUserDepartment(): String {
    return this.userCredential['departmentId'];
  }

  getUserDivision(): String {
    return this.userCredential['divisionId'];
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/service/authorize.service.ts